import React from "react";
import { Tooltip } from "@material-ui/core";
import { formatCount } from "../DataTagConstants";

const SEGMENTS = [
  { key: "completed", label: "Successful", color: "#2e9e5b" },
  { key: "failed", label: "Failed", color: "#d93025" },
  { key: "inProgress", label: "In progress", color: "#f5a000" },
  { key: "unsupported", label: "Unsupported", color: "#9aa0a6" },
  { key: "notTagged", label: "Not tagged", color: "#e3e6ef" },
];

const SIZE = 34;
const STROKE = 7;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const BLOCK_WIDTH = 136;
const MIN_SHARE = 0.04;

export default function TagStatusDonut({ tagging, totalFiles }) {
  const counts = SEGMENTS.map((s) => Number(tagging?.[s.key]) || 0);
  const total = counts.reduce((a, b) => a + b, 0);

  const shares = counts.map((c) => (c > 0 && total > 0 ? Math.max(c / total, MIN_SHARE) : 0));
  const shareSum = shares.reduce((a, b) => a + b, 0) || 1;

  let offset = 0;
  const arcs = SEGMENTS.map((s, i) => {
    const len = (shares[i] / shareSum) * CIRCUMFERENCE;
    const arc = { ...s, len, offset };
    offset += len;
    return arc;
  }).filter((a) => a.len > 0);

  const tagged = Number(tagging?.total) || 0;
  const files = Number(totalFiles) || total;

  return (
    <Tooltip
      placement="top"
      arrow
      title={
        <div style={{ padding: "2px 4px" }}>
          {SEGMENTS.map((s, i) => (
            <div
              key={s.key}
              style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12 }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: s.color,
                  border: s.key === "notTagged" ? "1px solid #b8bdd0" : "none",
                }}
              />
              {s.label}: {counts[i].toLocaleString()}
            </div>
          ))}
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          width: BLOCK_WIDTH,
        }}
      >
        <svg
          width={SIZE}
          height={SIZE}
          viewBox={`0 0 ${SIZE} ${SIZE}`}
          style={{ flexShrink: 0 }}
        >
          <circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            fill="none"
            stroke="#e3e6ef"
            strokeWidth={STROKE}
          />
          {arcs.map((a) => (
            <circle
              key={a.key}
              cx={SIZE / 2}
              cy={SIZE / 2}
              r={RADIUS}
              fill="none"
              stroke={a.color}
              strokeWidth={STROKE}
              strokeDasharray={`${a.len} ${CIRCUMFERENCE - a.len}`}
              strokeDashoffset={-a.offset}
              transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
            />
          ))}
        </svg>
        <span
          style={{
            flex: 1,
            minWidth: 0,
            textAlign: "left",
            fontSize: 12,
            color: "#5b6475",
            whiteSpace: "nowrap",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {formatCount(tagged)} / {formatCount(files)}
        </span>
      </div>
    </Tooltip>
  );
}